import PropTypes from 'prop-types'
import BaobabPropTypes from 'legacy/libs/baobab-prop-types'
import classNames from 'classnames'
import ReactDOM from 'react-dom'
import { BranchMixin } from 'legacy/libs/baobab-react-mixins'
import _ from 'lodash'
import $ from 'jquery'
import createReactClass from 'create-react-class'

/**
 * CollapsibleContainer component
 * @param {callback} [props.onCollapsedClick=_.constant(true)] -
 * The callback who will call on container header click.
 * If this function return false default click handler will be interrupted.
 */
export default createReactClass({
  displayName: 'CollapsibleContainer',

  mixins: [BranchMixin],

  propTypes: {
    id: PropTypes.string,
    cursor: BaobabPropTypes.cursor.isRequired,
    disabled: PropTypes.bool,
    onCollapsedChange: PropTypes.func,
    onCollapsedClick: PropTypes.func,
    unmountWhenCollapse: PropTypes.bool,
    header: PropTypes.any.isRequired, // eslint-disable-line
    className: PropTypes.string,
    headerClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    chevron: PropTypes.node.isRequired,
    children: PropTypes.node,
  },

  cursors(props) {
    return {
      collapsed: props.cursor,
    }
  },

  getDefaultProps() {
    return {
      onCollapsedChange: _.identity,
      onCollapsedClick: _.constant(true),
    }
  },

  getInitialState() {
    return {
      mounted: !this.props.cursor.get(),
    }
  },

  componentDidMount() {
    if (this.state.collapsed) {
      $(this.getContentNode()).hide()
    }
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Collapse if component becomes disabled
    if (nextProps.disabled !== this.props.disabled && nextProps.disabled) {
      this.cursors.collapsed.set(true)
    }
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevState.collapsed !== this.state.collapsed) {
      this.toggleCollapse(this.state.collapsed)
    }
  },

  animationInProgress: false,

  getContentNode() {
    return ReactDOM.findDOMNode(this.refs.content); // eslint-disable-line
  },

  toggleCollapse(collapsed) {
    // TODO: Need to find best way for this clever sliding
    // It saves us only of double-clicking
    this.animationInProgress = true

    const callback = () => {
      this.props.onCollapsedChange(collapsed)
      this.animationInProgress = false
    }

    const $element = $(this.getContentNode())
    const duration = 'fast'

    if (collapsed) {
      $element.slideUp(duration, () => {
        if (this.props.unmountWhenCollapse) {
          this.setState({ mounted: false }, callback)
        } else {
          callback()
        }
      })
    } else {
      this.setState({ mounted: true }, () => {
        $element.slideDown(duration, callback)
      })
    }
  },

  onHeaderClick() {
    if (
      !this.props.onCollapsedClick() ||
      this.animationInProgress ||
      this.props.disabled
    ) {
      return
    }

    this.cursors.collapsed.apply((x) => !x)
  },

  render() {
    return (
      <section className={this.props.className} id={this.props.id}>
        <button
          className={classNames(
            'items-top flex w-full text-left disabled:text-gray-drh',
            this.props.headerClassName
          )}
          ref="header"
          onClick={this.onHeaderClick}
          disabled={this.props.disabled}
          type="button"
        >
          {this.props.chevron}

          <div className="flex flex-wrap items-baseline gap-x-3">
            {this.props.header}
          </div>
        </button>

        <div className={this.props.contentClassName} ref="content">
          {this.state.mounted && this.props.children}
        </div>
      </section>
    )
  },
})
